import { useFilterStore } from '../stores/filter-store.ts';
import { useDimLabelMaps, fmtWg } from '../lib/useWgIdMap.ts';
import { Icon } from './Icon.tsx';

const DIM_LABELS: Record<string, string> = {
  store_number: 'Filiale',
  store_name: 'Filiale',
  warengruppe_name: 'Warengruppe',
  artikel_bezeichnung: 'Artikel',
  artikel_nr: 'Artikel-Nr',
  ean: 'EAN',
  kassierer_name: 'Kassierer',
  plz: 'PLZ',
  ort: 'Ort',
  jahr: 'Jahr',
  monat: 'Monat',
  wochentag: 'Wochentag',
  stunde: 'Stunde',
  datum: 'Zeitraum',
};

export function FilterChips() {
  const { filters, labels, removeFilter, clearAll } = useFilterStore();
  const labelMaps = useDimLabelMaps();
  const entries = Object.entries(filters);

  if (entries.length === 0) {
    return (
      <div className="px-4 lg:px-6 py-2 border-b border-slate-200/70 dark:border-slate-800/70 bg-white/60 dark:bg-slate-900/60">
        <div className="text-2xs text-slate-400 dark:text-slate-500 flex items-center gap-2">
          <Icon name="filter" size={12} />
          Keine Filter aktiv. Klicke auf einen Balken, eine Tabellenzeile oder ein Karten-Element, um zu filtern.
        </div>
      </div>
    );
  }

  return (
    <div className="px-4 lg:px-6 py-2 border-b border-slate-200/70 dark:border-slate-800/70 bg-white dark:bg-slate-900 flex flex-wrap gap-1.5 items-center animate-fade-in">
      <span className="inline-flex items-center gap-1.5 text-2xs uppercase tracking-wider font-semibold text-slate-500 dark:text-slate-400 mr-1">
        <Icon name="filter" size={11} />
        Aktive Filter
      </span>
      {entries.map(([dim, val]) => {
        const label = DIM_LABELS[dim] ?? dim;
        if (Array.isArray(val)) {
          return val.map((v) => {
            const display =
              labels[`${dim}:${v}`] ??
              (dim === 'warengruppe_name'
                ? fmtWg(String(v), labelMaps.warengruppe)
                : dim === 'artikel_bezeichnung'
                  ? fmtWg(String(v), labelMaps.artikel)
                  : String(v));
            return (
              <span key={`${dim}=${v}`} className="chip">
                <span className="opacity-60">{label}:</span>
                <span className="font-semibold">{display}</span>
                <span
                  className="chip-close"
                  onClick={() => removeFilter(dim, v as string | number)}
                  title="Entfernen"
                >
                  <Icon name="x" size={10} />
                </span>
              </span>
            );
          });
        }
        const range = val as { min?: string; max?: string };
        return (
          <span key={dim} className="chip">
            <span className="opacity-60">{label}:</span>
            <span className="font-semibold">
              {range.min ?? '−∞'} bis {range.max ?? '+∞'}
            </span>
            <span
              className="chip-close"
              onClick={() => removeFilter(dim)}
              title="Entfernen"
            >
              <Icon name="x" size={10} />
            </span>
          </span>
        );
      })}
      <button
        onClick={clearAll}
        className="btn-ghost text-2xs ml-auto"
        title="Alle Filter entfernen"
      >
        <Icon name="x" size={12} />
        Alle löschen
      </button>
    </div>
  );
}
